import { Component } from '@angular/core';

@Component({
    selector: 'app-iec',
    templateUrl: './iec.component.html',
    styleUrl: './iec.component.scss',
    standalone: false
})
export class IecComponent {

}
